const cloudSystem = {
  emitters: [
    {
      id: 1,
      layer: {
        type: 'string',
        value: 'background',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 200],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#5bc77e',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 20,
              value: [255, 255, 255, 0.02],
            },
            {
              keyframe: 40,
              value: [255, 255, 255, 0.02],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
    {
      id: 2,
      layer: {
        type: 'string',
        value: 'foreground',
      },
      position: {
        type: 'vectorRange',
        value: [
          [0, 0.2],
          [1.2, 1.2],
        ],
      },
      angle: {
        type: 'float',
        value: -3.14,
      },
      speed: {
        type: 'float',
        value: 0.1,
      },
      rate: {
        type: 'float',
        value: 11,
      },
      particle: {
        lifetime: {
          type: 'float',
          value: 6,
        },
        shape: {
          type: 'string',
          value: 'circle',
        },

        gravity: {
          type: 'float',
          value: 0.0005,
        },
        scale: {
          type: 'range',
          value: [20, 100],
        },
        edgeBehaviour: {
          type: 'string',
          value: 'none',
        },
        color: {
          type: 'colorOverLife',
          color: '#5bc77e',
          value: [
            {
              keyframe: 0,
              value: [255, 255, 255, 0],
            },
            {
              keyframe: 20,
              value: [255, 255, 255, 0.01],
            },
            {
              keyframe: 40,
              value: [255, 255, 255, 0.01],
            },
            {
              keyframe: 100,
              value: [255, 255, 255, 0],
            },
          ],
        },
      },
    },
  ],
  effects: [
    {
      type: 'impulse',
      emitters: [1, 2],
      energy: 'above',
      data: {
        direction: -3.14,
        amount: 0.004,
      },
    },
  ],
}

export default cloudSystem
